<div *ngIf='screenWidth > 767'>
  <div class="flex"></div>
  <div class="flex-444-px">
    <div class="bmw-profile-content">
      <div class="bmw-user-info-title">Password</div>
      <form [formGroup]='userForm' (ngSubmit)="onSubmit(userForm)">
        <label for="oldPassword">Old Password</label>
        <br>
        <input type="password" name="oldPassword" id="oldPassword" formControlName="oldPassword">
        <small *ngIf="userForm.get('oldPassword').hasError('required') && userForm.get('oldPassword').touched">Required</small>
        <br>
        <label style="margin-top:50px" for="newPassword">New Password</label>
        <div class="bmw-toggle-password-display pointer" (click)='togglePasswordDisplay()'>
          <span class="strike" *ngIf='!show'></span>
          <i style="font-size: 20px; vertical-align:middle" class="material-icons">remove_red_eye</i>
          <span style="font-weight:bold;" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{show ? "Hide" : "Show"}}</span>
        </div>
        <br>
        <input #inputPassword type="password" (input)='checkPasswordStrength()' name="newPassword" id="newPassword" formControlName="newPassword">
        <small *ngIf="userForm.get('newPassword').hasError('required') && userForm.get('newPassword').touched">Required</small>
        <br>
        <div id="strength" #strength>
          <ul id="strengthBar">
            <li class="point" [style.background-color]="bar0"></li>
            <li class="point" [style.background-color]="bar1"></li>
            <li class="point" [style.background-color]="bar2"></li>
          </ul>
        </div>
        <div class="bmw-password-policy">
          <ul>
            <li>8 Characters minimum</li>
            <li>1 Lowercase character</li>
            <li>No sequencing</li>
            <li>1-4 Numbers</li>
            <li>Symbol '#' or '$'</li>
          </ul>
        </div>
        <label for="confirmPassword">Confirm Password</label>
        <br>
        <input type="password" name="confirmPassword" (input)='verifyPassword()' id="confirmPassword" formControlName="confirmPassword">
        <small *ngIf="userForm.get('confirmPassword').hasError('required') && userForm.get('confirmPassword').touched">Required</small>
        <br>
        <button type='submit' [disabled]="userForm.invalid || !matchPwd || checkPasswordStrength() < 3" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-submit-button">Change Password</button>
      </form>
    </div>
  </div>
  <div class="flex"></div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div class="visible-xs">
    <div>
      <div class="bmw-profile-content bmw-xs">
        <div class="bmw-user-info-title">Password</div>
        <form [formGroup]='userForm' (ngSubmit)="onSubmit(userForm)">
          <label for="oldPassword">Old Password</label>
          <br>
          <input type="password" name="oldPassword" id="oldPassword" formControlName="oldPassword">
          <small *ngIf="userForm.get('oldPassword').hasError('required') && userForm.get('oldPassword').touched">Required</small>
          <br>
          <label style="margin-top:50px" for="newPassword">New Password</label>
          <div class="bmw-toggle-password-display bmw-xs pointer" (click)='togglePasswordDisplay()'>
            <span class="strike" *ngIf='!show'></span>
            <i style="font-size: 20px; vertical-align:middle" class="material-icons">remove_red_eye</i>
            <span style="font-weight:bold;" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{show ? "Hide" : "Show"}}</span>
          </div>
          <br>
          <input #inputPassword type="password" (input)='checkPasswordStrength()' name="newPassword" id="newPassword" formControlName="newPassword">
          <small *ngIf="userForm.get('newPassword').hasError('required') && userForm.get('newPassword').touched">Required</small>
          <br>
          <div id="strength" #strength>
            <ul id="strengthBar">
              <li class="point" [style.background-color]="bar0"></li>
              <li class="point" [style.background-color]="bar1"></li>
              <li class="point" [style.background-color]="bar2"></li>
            </ul>
          </div>
          <div class="bmw-password-policy">
            <ul>
              <li>8 Characters minimum</li>
              <li>1 Lowercase character</li>
              <li>No sequencing</li>
              <li>1-4 Numbers</li>
              <li>Symbol '#' or '$'</li>
            </ul>
          </div>
          <label for="confirmPassword">Confirm Password</label>
          <br>
          <input type="password" name="confirmPassword" (input)='verifyPassword()' id="confirmPassword" formControlName="confirmPassword">
          <small *ngIf="userForm.get('confirmPassword').hasError('required') && userForm.get('confirmPassword').touched">Required</small>
          <br>
          <button type='submit' [disabled]="userForm.invalid || !matchPwd || checkPasswordStrength() < 3" class="bmw-submit-button" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>Change Password</button>
        </form>
        <div [routerLink]='["/profile"]' class="bmw-button-secondary bmw-xs pointer" >Back</div>
      </div>
    </div>
  </div>
</div>